export default (officeModel) => {
  const inPresentationKey = 'In presentation'
  localStorage.removeItem(inPresentationKey)

  // Reminder: if changing roles, this interval will need to be cleared
  window.setInterval(function () {
    if (officeModel.isEditing() && localStorage.getItem(inPresentationKey)) {
      officeModel.set('activeView', 'read')
      console.log('activeView set to read')
    }
  }, 2000)

  officeModel.listenTo(officeModel, 'change:activeView', () => {
    if (officeModel.isPresenting()) {
      console.log('setting inPresentationKey set to true')
      localStorage.setItem(inPresentationKey, true)
      console.log('inPresentationKey set to true')
    } else {
      console.log('setting inPresentationKey to false')
      localStorage.removeItem(inPresentationKey)
      console.log('setting inPresentationKey to false (removed)')
    }
  })
}
